module.exports = __webpack_public_path__ + "static/media/iconeDelivery.8dbf8a54.svg";